<template lang="pug" src="./slider-office.pug"></template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        navigation: {
          prevEl: '.slider-office__prev-arrow',
          nextEl: '.slider-office__next-arrow'
        },
        pagination: {
          el: '.slider-office__pagination',
          clickable: true,
          bulletClass: 'slider-office__bullet',
          bulletActiveClass: 'slider-office__bullet-active',
          renderBullet: function (index, bulletClass) {
            return '<div class="' + bulletClass + '"></div>'
          }
        }
      }
    }
  },
  props: ['props'],
  components: {
    swiper,
    swiperSlide
  }
}
</script>



// WEBPACK FOOTER //
// src/components/slider/slider-office/slider-office.vue